module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('center', [(_vm.productConfig == '' || _vm.runSave == true) ? _c('img', {
    staticStyle: {
      "padding-top": "7%"
    },
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.productConfig != '' && _vm.runnSave == false && _vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productConfig != '' && _vm.runnSave == false && _vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), (_vm.productConfig != '' && _vm.runSave == false) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.productConfig.products,
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "32%"
          }
        }, [_vm._v(_vm._s(props.item.pli_code) + " - " + _vm._s(props.item.pli_description))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "28%"
          }
        }, [_c('v-select', {
          staticClass: "noBorder",
          attrs: {
            "items": _vm.productConfig.factories,
            "label": "Factory of Origin",
            "multiple": "",
            "solo": "",
            "item-value": "id"
          },
          model: {
            value: (props.item.factories),
            callback: function($$v) {
              _vm.$set(props.item, "factories", $$v)
            },
            expression: "props.item.factories"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "28%"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.transportCalc,
            "label": "Transport Calculation",
            "solo": "",
            "item-value": "id"
          },
          model: {
            value: (props.item.calc_mode),
            callback: function($$v) {
              _vm.$set(props.item, "calc_mode", $$v)
            },
            expression: "props.item.calc_mode"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "12%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.normalize_qty),
            callback: function($$v) {
              _vm.$set(props.item, "normalize_qty", $$v)
            },
            expression: "props.item.normalize_qty"
          }
        })], 1)]
      }
    }], null, false, 1575603783)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}